import { pvDebug } from '@/scripts/utils/helpers';
import { getCart, renderBNPLMemberships } from '@/scripts/cart/cart-bnpl-items';

function init(): void {
  pvDebug('cart-bnpl:start');
  const cart = getCart();
  if (!cart) return;

  document.addEventListener('DOMContentLoaded', function () {
    renderBNPLMemberships(
      cart.items.filter(
        (item) => item.properties._pay_later
      )
    );
  });
}

init();
